import { render, staticRenderFns } from "./HoldingInfoPane.vue?vue&type=template&id=f0a879c4&scoped=true&"
import script from "./HoldingInfoPane.vue?vue&type=script&lang=js&"
export * from "./HoldingInfoPane.vue?vue&type=script&lang=js&"
import style0 from "./HoldingInfoPane.vue?vue&type=style&index=0&id=f0a879c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a879c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VNavigationDrawer,VRow,VSimpleTable})
